import { useEffect, useRef, useState } from 'react';

const ANIMATION_STEP_DURATION = 2000;
const REPEAT_DURATION = 8000;

const useAnimation = () => {
  const [rotationOffset, setRotationOffset] = useState(0);
  const [isAnimated, setAnimated] = useState(false);
  const [isMoving, setMoving] = useState(false);
  const interval = useRef<number | null>(null);
  const timeout = useRef<number | null>(null);

  const startAnimation = () => {
    setAnimated(true);
    setMoving(true);
    setTimeout(() => {
      setRotationOffset(prev => prev + 1);
      setTimeout(() => {
        setMoving(false);
        setTimeout(() => {
          setAnimated(false);
        }, ANIMATION_STEP_DURATION);
      }, ANIMATION_STEP_DURATION);
    }, ANIMATION_STEP_DURATION);
  };
  const setAnimationInterval = (time: number) => {
    if (interval.current) clearInterval(interval.current);
    interval.current = window.setInterval(startAnimation, time);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (interval.current) clearInterval(interval.current);
      } else {
        setAnimationInterval(REPEAT_DURATION);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    setAnimationInterval(REPEAT_DURATION);

    return () => {
      if (interval.current) clearInterval(interval.current);
      if (timeout.current) clearTimeout(timeout.current);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const handleMouseEnter = () => {
    if (!isAnimated) {
      startAnimation();
      setAnimationInterval(REPEAT_DURATION - 1000);
    }
  };

  const handleMouseLeave = () => {
    setAnimationInterval(REPEAT_DURATION);
  };

  return {
    rotationOffset,
    isAnimated,
    isMoving,
    handleMouseEnter,
    handleMouseLeave,
  };
};

export default useAnimation;
